import { GetRequiredMilesResponse } from 'src/sdk-member';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetRequiredMilesModel } from './get-required-miles.state';

/** StateDetailsActions */
const ACTION_SET = '[GetRequiredMiles] set';
const ACTION_UPDATE = '[GetRequiredMiles] update';
const ACTION_RESET = '[GetRequiredMiles] reset';
const ACTION_FAIL = '[GetRequiredMiles] fail';
const ACTION_CANCEL_REQUEST = '[GetRequiredMiles] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetRequiredMiles] set from api';
const ACTION_UPDATE_FROM_API = '[GetRequiredMiles] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetRequiredMiles = createAction(ACTION_SET, props<WithRequestId<GetRequiredMilesModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetRequiredMiles = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<GetRequiredMilesModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetRequiredMiles = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetRequiredMilesRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetRequiredMiles = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetRequiredMilesFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetRequiredMilesResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetRequiredMilesFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetRequiredMilesResponse>>()
);
